export default "__VITE_ASSET__5cb41e40__"